module.exports = __webpack_public_path__ + "static/img/4963_phase_function_Paper_PointsHejduk_Prediction.900e293.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4963_phase_function_Paper_PointsHejduk_Prediction.png
// module id = tgRF
// module chunks = 0